const menu = [
  {
    name: "Products",
    link: "/products",
  },
  {
    name: "Testimonials",
    link: "/testimonials",
  },
  {
    name: "Investors",
    link: "/investors",
  },
  {
    name: "Liaison",
    link: "/liaison",
  },
  {
    name: "Downloads",
    link: "/downloads",
  },
  {
    name: "Contact",
    link: "/contact",
  },

];

const lang = {
  name: 'pl',
  link: 'https://rcmedical.pl/'
}


export { menu, lang };
